import { type IconComponentBaseProps } from '@/components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type CircleProps = IconComponentBaseProps;

export const Circle = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: CircleProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.50083 9C3.87841 9 3.29337 8.88189 2.74571 8.64568C2.19805 8.40947 1.72168 8.08891 1.31661 7.68399C0.911526 7.27907 0.590803 6.8029 0.354434 6.25547C0.118145 5.70805 0 5.12317 0 4.50083C0 3.87841 0.118105 3.29337 0.354316 2.74571C0.590526 2.19805 0.911092 1.72168 1.31601 1.31661C1.72093 0.911526 2.19711 0.590803 2.74453 0.354434C3.29195 0.118145 3.87683 0 4.49917 0C5.12159 0 5.70663 0.118105 6.25429 0.354316C6.80195 0.590526 7.27832 0.911092 7.6834 1.31601C8.08847 1.72093 8.4092 2.19711 8.64557 2.74453C8.88186 3.29195 9 3.87683 9 4.49917C9 5.12159 8.88189 5.70663 8.64568 6.25429C8.40947 6.80195 8.08891 7.27832 7.68399 7.6834C7.27907 8.08847 6.8029 8.4092 6.25547 8.64557C5.70805 8.88186 5.12317 9 4.50083 9ZM4.5 8.28947C5.55789 8.28947 6.45395 7.92237 7.18816 7.18816C7.92237 6.45395 8.28947 5.55789 8.28947 4.5C8.28947 3.44211 7.92237 2.54605 7.18816 1.81184C6.45395 1.07763 5.55789 0.710526 4.5 0.710526C3.44211 0.710526 2.54605 1.07763 1.81184 1.81184C1.07763 2.54605 0.710526 3.44211 0.710526 4.5C0.710526 5.55789 1.07763 6.45395 1.81184 7.18816C2.54605 7.92237 3.44211 8.28947 4.5 8.28947Z"
      fill={fill}
    />
  </svg>
);
